
process.env.SERVICE_TYPE = 'client';

const db = {
	file: 'kd.json',
	options: {
		autosave: true,
		autosaveInterval: 2000,
		env: 'BROWSER',
	},
};

const xenial = {
	url: 'https://uifuvdlsah.execute-api.us-east-1.amazonaws.com/iat/floor-plan',
};

/** Domain collections to be transferred to the socket clients  */

const domains = [
	'activity',
	'location',
	'limit',
	'reservation',
	'template',
	'chart',
	'note',
];

module.exports = {
	db,
	xenial,
	domains,
};



/** WEBPACK FOOTER **
 ** ./src/config/client.js
 **/